import React, { useEffect, useState } from 'react';

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from '@material-ui/core';

import ChoqueIcon from '../../../../assets/img/sinister/sinister_type/sinister_type_crash.svg';
import DanioIcon from '../../../../assets/img/sinister/sinister_type/sinister_type_damage.svg';
import IncendioIcon from '../../../../assets/img/sinister/sinister_type/sinister_type_fire.svg';
import InundacionIcon from '../../../../assets/img/sinister/sinister_type/sinister_type_flood.svg';
import GranizoIcon from '../../../../assets/img/sinister/sinister_type/sinister_type_hail.svg';
import RoboIcon from '../../../../assets/img/sinister/sinister_type/sinister_type_robbery.svg';
import Loader from '../../../../components/LoaderSplash/Loader.component';
// import IncendioIcon from '../../../../assets/img/Incendio.jpg';
// import InundacionIcon from '../../../../assets/img/Inundacion.jpg';
// import ChoqueIcon from '../../../../assets/img/choque.png';
// import DanioIcon from '../../../../assets/img/danio.png';
// import GranizoIcon from '../../../../assets/img/granizo.jpg';
// import RoboIcon from '../../../../assets/img/robo.png';
import {
  SINISTER_TYPE_CRASH,
  SINISTER_TYPE_DAMAGE,
  SINISTER_TYPE_FIRE,
  SINISTER_TYPE_FLOOD,
  SINISTER_TYPE_HAIL,
  SINISTER_TYPE_ROBBERY,
} from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';
import { vehicle as vehicleById } from '../../../../services/vehicles/vehicles.service';
import SelectionCards from '../Subcomponents/SelectionCards.component';

const SelectDamage = () => {
  const { updateSinisterBody, sinister_body } = useSinisterDataContext();
  const [assistance, setAssistance] = useState(false);
  const [hasProvider, setHasProvider] = useState(false);
  const [loading, setLoading] = useState(false);

  const DAMAGES = [
    {
      title: 'Daños por choque o accidente',
      caption: '¿Chocaste o te chocaron?',
      icon: ChoqueIcon,
      value: SINISTER_TYPE_CRASH,
    },
    {
      title: 'Sufrí un robo',
      caption: 'Total o parcial',
      icon: RoboIcon,
      value: SINISTER_TYPE_ROBBERY,
    },
    {
      title: 'Daños por granizo',
      icon: GranizoIcon,
      value: SINISTER_TYPE_HAIL,
    },
    {
      title: 'Daños por incendio',
      icon: IncendioIcon,
      value: SINISTER_TYPE_FIRE,
    },
    {
      title: 'Daños por inundación',
      icon: InundacionIcon,
      value: SINISTER_TYPE_FLOOD,
    },
    {
      title: 'Otros daños',
      caption: '(Cristales, cerraduras, etc)',
      icon: DanioIcon,
      value: SINISTER_TYPE_DAMAGE,
    },
  ];

  const handleCheckbox = (assistance: boolean) => {
    setAssistance(!assistance);
    updateSinisterBody({ need_assistance: !assistance });
  };

  useEffect(() => {
    searchVehiclesById(sinister_body.vehicle_id);
  }, [sinister_body.vehicle_id]);

  const searchVehiclesById = async (id: number) => {
    setLoading(true);

    const vehicle = await vehicleById(id);
    if (vehicle.data?.assistance_provider?.phone) setHasProvider(true);

    setLoading(false);
  };

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>

      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography
              variant="h6"
              style={{ fontFamily: 'Inter', color: '#000' }}
            >
              ¿Qué te ocurrió?
            </Typography>
          </Box>
        </Grid>
        <SelectionCards
          relatedField={'incident_type'}
          cards={DAMAGES}
        ></SelectionCards>
      </Grid>
      {sinister_body.can_request_assistance && (
        <>
          {hasProvider && (
            <Grid container item xs={12}>
              <Box mr={2} my={2}>
                <FormControl component="fieldset">
                  <FormGroup aria-label="position">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={assistance}
                          onChange={() => handleCheckbox(assistance)}
                          name="side_windows"
                        />
                      }
                      label="Necesito una grúa para mi vehículo"
                    />
                  </FormGroup>
                </FormControl>
              </Box>
            </Grid>
          )}
          <Box mr={2} my={2}>
            <Typography>
              {' '}
              Al finalizar la denuncia te asistiremos para coordinar los pasos y
              ayudarte con tu vehículo.{' '}
            </Typography>
          </Box>
        </>
      )}
    </>
  );
};

export default SelectDamage;
